import { type JanusCtx, record, upper } from '../ability/context.js';
import { C1_PROVISIONAL_STATUS_ID } from '../compile/possessor-compile.js';

const UUID = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/;
// Status-chain previews share this reserved namespace across creatures and actions.
const browserId = (id: string): boolean => UUID.test(id) && !id.startsWith(C1_PROVISIONAL_STATUS_ID.slice(0, -12));

/** Browser-minted identities are retained by the insert-only action save. */
export function assignFreshStatusIds(ctx: JanusCtx): void {
  if (!ctx.statusesAdded.length) return;
  const used = new Set(ctx.statusesRemoved.map(row => upper(ctx.read.value(row, 'status_id'))).filter(Boolean));
  for (const member of (ctx.originals ?? ctx.members).values())
    for (const row of ctx.read.statuses(member)) {
      const id = upper(ctx.read.value(row, 'status_id'));
      if (id) used.add(id);
    }
  for (const row of ctx.statusesAdded) {
    let id = upper(ctx.read.value(record(row), 'status_id'));
    if (!browserId(id) || used.has(id)) {
      id = upper(ctx.read.uuid());
      // Deterministic replay readers may repeat ids; page-local projections still need distinct ids.
      while (!browserId(id) || used.has(id)) id = crypto.randomUUID().toUpperCase();
    }
    row.status_id = id;
    used.add(id);
  }
}
